import styled from '@emotion/styled';
import { Button, IconButton } from '@mui/material';
import { colors } from 'crono-fe-common/theme';

/** @deprecated Use `Button` from `@crono-one/design-system` instead. */
export const MainPrimaryButton = styled(Button)<{ disabled?: boolean | null }>`
  && {
    background-color: ${(props) =>
      props.disabled ? colors.grey11 : colors.primary} !important;
    color: ${colors.white} !important;
    border-radius: 9999px;
    margin: 0px;
    font-size: 16px;
    line-height: 24px;
    font-weight: 500;
    text-transform: unset !important;
    padding-inline: 16px;
    padding-block: 12px;
    &:hover {
      background-color: ${(props) =>
        props.disabled ? undefined : colors.primaryDark} !important;
    }
  }
`;

/** @deprecated Use `Button` from `@crono-one/design-system` instead. */
export const ChipNearNameButton = styled(Button)`
  && {
    // background-color: ${colors.primary} !important;
    // color: ${colors.white} !important;
    gap: 4px !important;
    border-radius: 9999px;
    margin: 0px;
    font-size: 16px;
    line-height: 20px;
    font-weight: 500;
    text-transform: unset !important;
    padding-inline: 8px;
    padding-block: 6px;
    & > span {
      margin-inline: 0px !important;
      & > svg {
        font-size: 16px !important;
      }
    }
  }
`;

/** @deprecated Use `Button` from `@crono-one/design-system` instead. */
export const MainPrimarySmallButton = styled(Button)<{
  disabled?: boolean | null;
  height?: string;
}>`
  && {
    ${({ height }) => height && `height: ${height};`}
    background-color: ${(props) =>
      props.disabled ? colors.grey11 : colors.primary} !important;
    color: ${colors.white} !important;
    border-radius: 9999px;
    margin: 0px;
    font-size: 14px;
    line-height: 18px;
    font-weight: 500;
    text-transform: unset !important;
    padding-inline: 16px;
    padding-block: 7px;
    &:hover {
      background-color: ${colors.primaryDark} !important;
    }
  }
`;

/** @deprecated Use `Button` from `@crono-one/design-system` instead. */
export const MainLightPrimarySmallButton = styled(Button)`
  && {
    background-color: ${colors.primaryLightHover} !important;
    color: ${colors.primary} !important;
    border-radius: 9999px;
    margin: 0px;
    font-size: 14px;
    line-height: 18px;
    font-weight: 500;
    text-transform: unset !important;
    padding-inline: 16px;
    padding-block: 7px;
    &:hover {
      background-color: ${colors.primaryLightHoverHover} !important;
    }
  }
`;

/** @deprecated Use `Button` from `@crono-one/design-system` instead. */
export const RewriteButton = styled(Button)<{
  disabled?: boolean | null;
  height?: string;
}>`
  && {
    ${({ height }) => height && `height: ${height};`}
    background-color: ${(props) =>
      props.disabled
        ? colors.grey444
        : colors.rewriteCreditsBackground} !important;
    color: ${(props) =>
      props.disabled ? colors.grey11 : colors.mainDark} !important;
    border-radius: 9999px;
    margin: 0px;
    font-size: 14px;
    line-height: 18px;
    font-weight: 500;
    text-transform: unset !important;
    padding-inline: 16px;
    padding-block: 7px;
    &:hover {
      background-color: ${colors.rewriteCreditsBackgroundHover} !important;
    }
  }
`;

/** @deprecated Use `Button` from `@crono-one/design-system` instead. */
export const MainButton = styled(Button)<{
  disabled?: boolean | null;
  width?: string;
  height?: string;
  margin?: string;
  fontWeight?: string;
  fontSize?: string;
  paddingInline?: string;
  textColor?: string;
}>`
  && {
    background-color: ${(props) =>
      props.disabled ? colors.grey11 : colors.mainDark};
    color: ${(props) =>
      props.textColor ? props.textColor : colors.white} !important;
    border-radius: 9999px;
    margin: ${(props) => props.margin || '6px'};
    font-size: ${(props) => props.fontSize || '16px'};
    font-weight: ${(props) => props.fontWeight || '500'};
    line-height: 24px;
    ${(props) => (props.width ? { width: props.width } : {})};
    height: ${(props) => props.height || '48px'};
    text-transform: unset !important;
    padding-inline: ${(props) => props.paddingInline || '20px'};
    &:hover {
      cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
      background-color: ${colors.black}cc;
    }
  }
`;

/** @deprecated Use `Button` from `@crono-one/design-system` instead. */
export const CancelButton = styled(Button)<{
  fontWeight?: string;
  width?: string;
  margin?: string;
  borderWidth?: string;
}>`
  && {
    background: ${colors.white} !important;
    color: ${colors.black} !important;
    border-radius: 9999px;
    margin: ${(props) => props.margin || '6px'};
    font-size: 16px;
    font-weight: ${(props) => props.fontWeight || '500'};
    line-height: 24px;
    height: 48px;
    ${(props) => (props.width ? { width: props.width } : {})};
    text-transform: unset !important;
    border: 2px solid ${colors.grey4};
    padding-inline: 20px;
    border-width: ${(props) => props.borderWidth || '2px'};
  }
  &&:hover {
    background: ${colors.grey4} !important;
  }
`;

/** @deprecated Use `IconButton` from `@crono-one/design-system` instead. */
export const CloseButton = styled(IconButton)`
  && {
    background: ${colors.grey6} !important;
    color: ${colors.grey11} !important;
    border-radius: 10px;
  }
`;

/** @deprecated Use `Button` from `@crono-one/design-system` instead. */
export const RedButton = styled(Button)<{ disabled?: boolean | null }>`
  && {
    background-color: ${(props) =>
      props.disabled ? colors.inactiveLight : colors.inactive};
    color: ${colors.white} !important;
    border-radius: 9999px;

    font-size: 16px;
    font-weight: 500;
    line-height: 24px;
    height: 40px;
    text-transform: unset !important;
    padding-inline: 20px;
    &:hover {
      background-color: ${colors.inactiveHover};
    }
  }
`;
